import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import * as d3 from 'd3';

import * as t from 'topojson';

//declare var d3:any;

@Component({
  selector: 'app-map-bubble-chart',
  templateUrl: './map-bubble-chart.component.html',
  styleUrls: ['./map-bubble-chart.component.css']
})

export class MapBubbleChartComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    var width = 800;
    var height = 800;


    let projection = d3.geoMercator().center([0, 45.8])
    .rotate([-15, 0])
    .scale(10000)
    .translate([width / 2, height / 2]);

    let svg = d3.select('body').append('svg')
      .attr('width', width)
      .attr('height', height);
    let path = d3.geoPath()
      .projection(projection);
    let g = svg.append('g');
    g.attr('class', 'map');


    var markers = [
      {long: 15.08056, lat: 46.51028}
    ];

        d3.json("./assets/svn.geojson").then(function(sr: any) {
      // Filter data
      //data.features = data.features.filter( function(d){return d.properties.name=="Slovenia"} )
      g.selectAll(".subunit")
      .data(sr.features)
        .enter()
        .append("path")
      .attr("class", function(d: any) { return "subunit " + d.properties.sr_sov_a3; })
        .attr("d", path)
      .style("stroke", "rgba(22,22,22,0.5)")
      .style("fill", "yellow")
      .on("mouseover",
      function(d: any) {
      d3.select(this)
      .style("fill", "yellow")
      .style("stroke", "rgba(22,22,22,0.5)")
      .transition()
      .style("fill", "orange")
      .style("stroke", "rgba(255,255,255,1)");


      d3.select(".subunit-label." + d.properties.adm1_code)
      .classed("bold", true);
      })
      .on("mouseout", function(d: any) {
      d3.select(this)
      .transition()
      .style("fill", "yellow")
      .style("stroke", "rgba(22,22,22,0.5)");

      d3.select(".subunit-label." + d.properties.adm1_code)
      .classed("bold", false);


      });

      g.selectAll(".subunit-label")
      .data(sr.features)
          .enter().append("text")
      .attr("class", function(d: any) { return "subunit-label " + d.properties.adm1_code; })
      .attr("transform", function(d: any) { return "translate(" + path.centroid(d) + ")"; })
      .attr("dy", ".35em")
      //.text(function(d: any) { return d.properties.name; });

      g
      .selectAll("myCircles")
      .data(markers)
      .enter()
      .append("circle")
        .attr("cx", function(d){ return projection([d.long, d.lat])[0] })
        .attr("cy", function(d){ return projection([d.long, d.lat])[1] })
        .attr("r", 14)
        .style("fill", "69b3a2")
        .attr("stroke", "#69b3a2")
        .attr("stroke-width", 3)
        .attr("fill-opacity", .4)

    })
  }
}
